import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers, queryParameters } from "../module_auth/AuthService"
import { PaginationCustom } from "../component/common/PaginationCustom"
import { BlogCard } from "./BlogCard"
import { useNavigate } from "react-router-dom"
import { isValidSearchPage, sendGoogleAnalytics } from './common/BaseUtil';
//user tracking
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';

export function BlogList() {
    const navigate = useNavigate();

    const location = useLocation();

    const [blogList, setBlogList] = useState([]);

    ////pagination
    const [pageList, setPageList] = useState([]);
    const [lastPage, setLastPage] = useState();
    const [activePageIndex, setActivePageIndex] = useState();
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const page = queryParameters.get("page")
    const next = queryParameters.get("next")
    const previous = queryParameters.get("previous")
    ////pagination

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)

        //currentPage
        let currentPage
        if(!isValidSearchPage(page)){
            let localStoragePage = localStorage.getItem("page")
            currentPage = !isValidSearchPage(localStoragePage) ? "1" : localStorage.getItem("page")
        } else {
            currentPage = page == "0" ? "1" : page
        }
        setCurrentPage(currentPage)
        //end currentPage

        navigate("/blog_list?page="  + currentPage);
        localStorage.setItem("page", currentPage)
        let url = basePort + '/get/blogs/' + currentPage
        //10페이지 이후의 페이지네이션 개발필요
        let activePageIndex = (currentPage-1)%10
        if(next != null){
            url = basePort + '/get/blogs/next/' + currentPage
            activePageIndex = (currentPage-1)%10
        } else if(previous != null) {
            url = basePort + '/get/blogs/previous/' + currentPage
            activePageIndex = (currentPage-1)%10
        }
        
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
            setBlogList(response.cardList)
            
            ////pagination
            setPageList(response.displayPages)
            setLastPage(response.lastPage)
            setActivePageIndex(activePageIndex)
            ////pagination

          }).catch(error => console.log(error))
    }, []);

    return (
        <div>
            <Helmet>
                <title>지워커 | 독일 블로그 최신 소식</title>
                <meta name="description" content="독일에 거주하는 한국인을 위한 최신 블로그와 생활 정보, 여행, 정책, 문화 소식을 제공합니다." />
                <meta name="keywords" content="독일 블로그, 독일한인교민, 독일최신정보, 독일정책, 독일사회변화" />
                <link rel="canonical" href={`https://www.g-worker.co.kr/blog_list?page=${currentPage}`} />
                <meta property="og:title" content="지워커 | 독일 블로그 최신 소식" />
                <meta property="og:description" content="독일 거주 한국인을 위한 블로그 소식과 생활, 여행, 정책 정보를 확인하세요." />
                <meta property="og:url" content={`https://www.g-worker.co.kr/blog_list?page=${currentPage}`} />
                {currentPage > 1 && <link rel="prev" href={`https://www.g-worker.co.kr/blog_list?page=${currentPage-1}`} />}
                {currentPage < lastPage && <link rel="next" href={`https://www.g-worker.co.kr/blog_list?page=${currentPage+1}`} />}
            </Helmet>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>블로그</span></li>
                        </ol>
                    </div>
                    <div class="container">
                        <div className="dynamic-list">
                            {blogList.map((object, index) => (
                                <article key={index}>
                                    <BlogCard object={object} index={index}/>
                                </article>
                            ))}
                        </div>
                    </div>
                    
                    <PaginationCustom 
                        lastPage={lastPage}
                        page={page}
                        pageList={pageList}
                        activePageIndex={activePageIndex}
                        url={'blog_list'}
                    />

                </section>
            </main>
        </div>
    );
}